import { render, staticRenderFns } from "./PhanTichPhaiThuKhachHangNuoc.vue?vue&type=template&id=1983c472"
import script from "./PhanTichPhaiThuKhachHangNuoc.vue?vue&type=script&lang=js"
export * from "./PhanTichPhaiThuKhachHangNuoc.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports